import { ActivityLogSource } from "@/enums/enums";
import { AccessToken, RefreshToken } from "@/helper/userHelper";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class AuthenService {
  DoGetAccessToken(_input: any, source = ActivityLogSource.None) {
    /* eslint-disable @typescript-eslint/camelcase */
    const data = qs.stringify({
      grant_type: "password",
      client_id: "account",
      client_secret: "accountSecret",
      scope: "payroll.api.full offline_access openid",
      username: _input.userName,
      password: _input.password,
      user_type: _input.userType,
      token: "",
      source: source,
    });

    return service.peakAuthen
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  }

  DoGetNewAccessTokenByRefreshToken() {
    /* eslint-disable @typescript-eslint/camelcase */
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: "account",
      client_secret: "accountSecret",
      refresh_token: RefreshToken(),
    });

    return service.peakAuthen
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetUserInfo() {
    const headers = {
      Authorization: `Bearer ${AccessToken()}`,
    };
    const params = {};
    return service.peakRealTimeAPIForUser.get("/api/User/GetUserInfoByUserId", { params, headers }).then((res) => {
      return res;
    });
  }
  DoRevokeAccessToken() {
    /* eslint-disable @typescript-eslint/camelcase */
    const accessToken = AccessToken();
    if (accessToken) {
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: accessToken,
        token_type_hint: "access_token",
      });

      return service.peakAuthen
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  }
  DoRevokeRefreshToken() {
    /* eslint-disable @typescript-eslint/camelcase */
    const refreshToken = RefreshToken();
    if (refreshToken) {
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: refreshToken,
        token_type_hint: "refresh_token",
      });

      return service.peakAuthen
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  }
  DoRevokeToken(idToken: string, userId: string) {
    const data = qs.stringify({});
    return service.peakAuthen
      .get("/connect/endsession?id_token_hint=" + idToken + "&eui=" + userId, data)
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetRefreshTokenExpiration() {
    let refreshToken = RefreshToken();
    if (refreshToken) {
      refreshToken = JSON.stringify(refreshToken);
    }
    return service.peakAuthen
      .post("/token/GetRefreshTokenExpiration", refreshToken, {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }

  DoIntrospectAccessToken() {
    const data = qs.stringify({
      client_secret: "account.api.secret",
      client_id: "account.api",
      token: AccessToken(),
    });
    return service.peakAuthen
      .post("/connect/introspect", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
}

export default new AuthenService();
